<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_finance">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="359" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_finance_main" class="page_main_contents">
          <div class="news_list">
            <h3>2024.06.25</h3>
            <p><a href="http://www.tv-asahipro.co.jp/pdf/koukoku202403.pdf" target="_blank">第66期決算公告 (自2023年4月1日～至2024年3月31日)<br /> (PDFダウンロード)</a></p>
          </div><!-- .news_list -->

          <div class="news_list">
            <h3>2023.06.19</h3>
            <p><a href="http://www.tv-asahipro.co.jp/pdf/koukoku202303.pdf" target="_blank">第65期決算公告 (自2022年4月1日～至2023年3月31日)<br /> (PDFダウンロード)</a></p>
          </div><!-- .news_list -->

          <div class="news_list">
            <h3>2022.06.24</h3>
            <p><a href="http://www.tv-asahipro.co.jp/pdf/koukoku202203.pdf" target="_blank">第64期決算公告 (自2021年4月1日～至2022年3月31日)<br /> (PDFダウンロード)</a></p>
          </div><!-- .news_list -->

          <div class="news_list">
            <h3>2021.06.23</h3>
            <p><a href="http://www.tv-asahipro.co.jp/pdf/koukoku202103.pdf" target="_blank">第63期決算公告 (自2020年4月1日～至2021年3月31日)<br /> (PDFダウンロード)</a></p>
          </div><!-- .news_list -->

          <div class="news_list">
            <h3>2020.06.19</h3>
            <p><a href="http://www.tv-asahipro.co.jp/pdf/koukoku202003.pdf" target="_blank">第62期決算公告 (自2019年4月1日～至2020年3月31日)<br /> (PDFダウンロード)</a></p>
          </div><!-- .news_list -->

        </div><!-- #company_finance_main -->


      </div><!-- #company_finance -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'history_index',
  components: {
    companyPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/finance_index.vue